module.exports = __webpack_public_path__ + "files/198a4f60cb1d0125e7fd19025b27c482.png";